module.exports = __webpack_public_path__ + "static/media/gifts-icon.00880c82.svg";